import { render } from "./red_overlay.vue?vue&type=template&id=43f8c410&scoped=true"
import script from "./red_overlay.vue?vue&type=script&lang=js"
export * from "./red_overlay.vue?vue&type=script&lang=js"

import "./red_overlay.vue?vue&type=style&index=0&id=43f8c410&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f8c410"]])

export default __exports__